var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"imageC",attrs:{"src":_vm.visible_bold ? _vm.icon_pdf1 : _vm.icon_pdf},on:{"click":function($event){return _vm.moreEvent(0)}}}),(_vm.visible_bold)?_c('xiangqing',{attrs:{"island":_vm.visible_bold,"record":_vm.record},on:{"child":_vm.moreEvent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }